import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { TRowActionResponse } from './types';

export const shouldDebugGridActions = false;

export function fixGridXml() {}

const addRow = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
  },
  TDataGridThunkState
>('dataGridSlice/addRow', async ({ gridId }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'add',
      context: state.context,
      cantRowsToAdd: 1,
    }),
  );
  if (shouldDebugGridActions) console.log('add', result?.data);
  if (result?.data)
    return {
      focusColumn: 1,
      focusGrid: true,
      focusRow: state.rows.length,
      newSelectedRows: [state.rows.length],
      xmlResponse: result?.data,
    };

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default addRow;
